// src/com/user_info/UserAndAlloc.js
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import UserInfo from './UserInfo';
import UserAlloc from '../user_alloc/UserAlloc';
import { AppMenuUrl } from '../../value/AppConst';
import AuthTable from '../auth_table/AuthTable';

export default function UserAndAlloc({
    menu, parentMenu
}) {
    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    // 사용자 정보, 승인요청 정보
    return(
        <TopViewControl>
            {
                (() => {
                    if(menu.menuUrl===AppMenuUrl.UserInfo)
                        return <UserInfo viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.AllocInfo)
                        return <UserAlloc viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.UserProc)
                        return <AuthTable viewServiceTags={viewServiceTags} />;
                    return null;
                })()
            }
        </TopViewControl>
    );
}